import {Box, Typography} from '@mui/material';
import {AppEllipsisTypography} from 'components/typographies';
import {SprintResponseModel} from 'models/sprint.model';
import React from 'react';
interface Props {
    sprint: SprintResponseModel;
}
export const SprintTitleRenderer: React.FC<Props> = ({sprint}) => {
    return (
        <Box display="flex" flexDirection="column">
            <AppEllipsisTypography variant="body1" text={sprint.title} maxLetters={35} style={{marginBottom: '-5px'}} />
            {sprint.startData && sprint.endData && (
                <Typography variant="caption" color="textSecondary">
                    {new Date(sprint.startData).toLocaleDateString()} - {new Date(sprint.endData).toLocaleDateString()}
                </Typography>
            )}
        </Box>
    );
};

export default SprintTitleRenderer;
